import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Services from "./components/Services";
import Industries from "./components/Industries";
import PageHeader from "./components/PageHeader";
import Footer from "./components/Footer";
import { getLang } from "./lib";
import { ROUTES, getRoutePath } from "./Resources/routes";

function App() {
  const lang = getLang();

  const routesConfig = [
    { path: ROUTES.HOME, Component: Home },
    { path: ROUTES.ABOUT, Component: About },
    { path: ROUTES.SERVICES, Component: Services },
    { path: ROUTES.INDUSTRIES, Component: Industries },
    { path: ROUTES.CONTACT, Component: Contact },
  ];

  return (
    <BrowserRouter>
      <div className="App">
        <PageHeader langName={lang} />

        <Routes>
          {routesConfig.map(({ path, Component }) => (
            <Route
              key={path}
              path={getRoutePath(path, lang)}
              element={<Component />}
            />
          ))}
          {/* Fallback route */}
          <Route path="*" element={<Home />} />
        </Routes>

        <Footer langName={lang} />
      </div>
    </BrowserRouter>
  );
}

export default App;
